import {gsap} from "gsap";
import {animateTitle} from "./scrollTitle";

window.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector<HTMLElement>(".WheelOfTasksComponent");

    if (element) {
        new WheelOfTasks(element);
    }
});

class WheelOfTasks {
    private value;
    private button;
    private list;
    private hasCookie: boolean = false;
    private overview;
    private wheelNavButtons;

    constructor(private element: HTMLElement) {
        this.init();
    }

    private init() {
        this.switchUser();
        this.spin();
        this.buttonEffect();
        this.overviewDisplay();
    }

    private spin() {
        this.overview = document.querySelector('.OverviewComponent');
        this.wheelNavButtons = document.querySelector<HTMLButtonElement>('.WheelOfTasksComponent .navButtons')
        this.button = this.element.querySelector<HTMLButtonElement>(".button");

        const dateString = this.button.getAttribute("data-next-sunday");
        const nextSunday = new Date(dateString);
        const nextSundayUTC = nextSunday.toUTCString();

        this.hasCookie = document.cookie
            .split('; ')
            .some(item => item === 'spinned=true');

        this.list = this.element.querySelector<HTMLElement>(".tasks");
        let children = this.list.querySelectorAll('.task');
        let tasks = gsap.utils.toArray<HTMLElement>(children);
        const originalTaskLength = tasks.length;

        this.button.addEventListener("click", () => {

            if (tasks.length <= originalTaskLength) {
                for (let i = 0; i < 11; i++) {
                    children.forEach(child => {
                        const clone = child.cloneNode(true);
                        this.list.appendChild(clone);
                    });
                }
            }

            children = this.list.querySelectorAll('.task');
            tasks = gsap.utils.toArray<HTMLElement>(children);
            const id = Number(this.value);
            const firstItem = this.list.querySelector(`.task[data-person-id="${id}"]`);
            if (!(firstItem === null)) {
                const itemIndex = firstItem.getAttribute('data-task-index');

                const goToIndex = (originalTaskLength * 10) + parseFloat(itemIndex);

                const targetTask = tasks[goToIndex];
                const rect = targetTask?.getBoundingClientRect();
                const viewportCenter = window.innerWidth / 2;
                const taskCenter = rect ? rect.width / 2 : 0;

                const currentX = gsap.getProperty(this.list, "x") as number;
                const distanceToCenter = rect ? rect.left + taskCenter - viewportCenter : 0;
                const toPosition = currentX - distanceToCenter;


                // Reset list to start
                gsap.set(this.list, {
                    x: 0
                })
                const hasCookie = this.hasCookie
                const bar = document.querySelector(".WheelOfTasksComponent .line2")

                gsap.set(bar, {
                    opacity: 1,
                    clearProps: "width"
                });


                // Move list to item
                let tl = gsap.timeline();
                const length = originalTaskLength * 11;
                let curIndex = 0;
                const child = this.list.querySelector('.task');
                const blockWidth = child.getBoundingClientRect().width;
                let wheelNavButtons = this.wheelNavButtons;
                let overview = this.overview;

                tl.to(this.list, {
                    x: toPosition,
                    duration: 10,
                    ease: Math.random() < 0.1 ? "back.out(0.5)" : "power3.out",
                    onUpdate: () => {
                        const translated = (gsap.getProperty(this.list, "x") as number) + blockWidth / 2; //aantal pixels van de totale width dat die is opgeschoven.
                        const translatedPos = Math.ceil(Math.abs(translated));
                        const index = Math.ceil(translatedPos / blockWidth);

                        if (index !== curIndex) {
                            const tik: HTMLAudioElement = document.querySelector(".WheelOfTasksComponent #tikAudio")

                            tik.currentTime = 0;
                            tik.play();

                            curIndex = index;
                        }
                    },
                    onComplete: async function () {
                        if (!hasCookie) {
                            document.cookie = `spinned=true; expires=${nextSundayUTC}; path=/`;
                        }


                        const formData = new FormData();
                        formData.append('action', 'handle_spin_complete');
                        formData.append('security', (window as any).ajax.nonce);

                        try {
                            const response = await fetch((window as any).ajax.url, {
                                method: 'POST',
                                body: formData,
                                headers: {
                                    'Accept': 'application/json',
                                },
                            });

                            const data = await response.json();
                            const list: Array<any> = data.data.persons_tasks;

                            list?.forEach(item => {
                                //const person = item[0];
                                let task = item[1];

                                if (task === '') {
                                    task = 'Niks';
                                }

                                //const card = document.querySelector(`.card[data-person-id="${person}"]`);
                                //const taskName = card?.querySelector('.taskName');
                                //taskName.innerHTML = task;
                            });

                            overview?.setAttribute('data-spinned', 'true');

                            wheelNavButtons.style.opacity = "1";
                            wheelNavButtons.style.pointerEvents = "auto";
                            overview.style.display = "flex";

                            const event = new CustomEvent("spinEnd");
                            window.dispatchEvent(event);

                            const title = document.querySelector<HTMLElement>(".OverviewComponent .title");
                            animateTitle(title)

                        } catch (error) {
                            console.error(error);
                        }
                    },


                });
                tl.to(bar, {
                    opacity: 0,
                    duration: 0.8,
                    width: "+=15",
                }, ">")

                tl.to(targetTask, {
                    scale: 1.25,
                    zIndex: -9999,
                    duration: 0.4,
                }, "<")

                tl.to(targetTask, {
                    scale: 1,
                    zIndex: 1,
                    duration: 0.4,
                }, ">")

            } else {
                console.log("id = null")
            }
        });
    }

    private buttonEffect() {
        const select = this.element.querySelector<HTMLSelectElement>("#selectName")
        const name = document.querySelector(".WheelOfTasksComponent .name")
        const button = this.button
        const span = document.querySelector(".WheelOfTasksComponent span");
        const buttonContainer = this.element.querySelector<HTMLSelectElement>(".buttonContainer")
        let mm = gsap.matchMedia();
        const cookie = this.hasCookie

        function mouseEnter() {
            mm.add("(min-width: 576px)", () => {
                if (select && select.value == "") {
                    gsap.to(button, {
                        x: 100,
                        duration: 0.5,
                        ease: "power3.out",
                    });
                }
            });
        }

        function mouseLeave() {
            mm.add("(min-width: 576px)", () => {

                if (select && select.value == "") {
                    gsap.to(button, {
                        x: 0,
                        duration: 0.5,
                        ease: "elastic.out(0.7)",
                    });
                }
            });
        }

        function mouseClick() {
            mm.add("(max-width: 576px)", () => {

                if (select && select.value == "") {
                    let tl = gsap.timeline()
                    tl.to(button, {
                        x: 10,
                        duration: 0.05,
                    });
                    tl.to(button, {
                        x: -10,
                        duration: 0.1,
                    });
                    tl.to(button, {
                        x: 0,
                        duration: 0.05,
                    });
                }
            });
        }

        function updateButton() {
            if (select && select.value !== "" || name) {
                button.style.opacity = "1";
            }
        }

        function hoverButton() {

            if (select && select.value !== "" || name) {
                console.log("mouseenter")
                let tl = gsap.timeline({paused: true,});

                tl.to(span, {duration: 0.2, xPercent: -150, ease: "power2.in"});
                tl.set(span, {xPercent: 150});
                tl.to(span, {duration: 0.2, xPercent: 0});

                tl.play(0);
            }
        }

        buttonContainer.addEventListener("mouseenter", mouseEnter);
        buttonContainer.addEventListener("mouseleave", mouseLeave);
        button.addEventListener("click", mouseClick);

        if (select) {
            select.addEventListener("change", updateButton);
        }
        button.addEventListener("mouseenter", hoverButton);
    }

    private switchUser() {
        const selectedName = this.element.querySelector<HTMLSelectElement>("#selectName");

        if (selectedName) {
            selectedName.addEventListener("change", (e) => {
                const target = e.currentTarget as HTMLSelectElement;
                this.value = target.value;
            });
        } else {
            const current_user_id = (window as any).user_id;
            this.value = current_user_id;
        }
    }

    private overviewDisplay() {

        if (this.hasCookie === true) {
            this.wheelNavButtons.style.opacity = "1";
            this.wheelNavButtons.style.pointerEvents = "auto";
            this.overview.style.display = "flex";
        }
    }
}
